var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback, useEffect, useRef } from 'react';
import { Counter } from '@snack-uikit/counter';
import { Typography } from '@snack-uikit/typography';
import { TYPE } from '../../constants';
import { useTabBarContext, useTabsContext } from '../../context';
import { getTabContentId } from '../../utils';
import styles from './styles.module.css';
const MAP_TYPE_TO_PROPS = {
    [TYPE.Primary]: {
        typographyProps: {
            purpose: 'title',
            size: 'm',
        },
        counterProps: {
            size: 'm',
        },
    },
    [TYPE.Secondary]: {
        typographyProps: {
            purpose: 'label',
            size: 'l',
        },
        counterProps: {
            size: 's',
        },
    },
};
export function Tab(_a) {
    var { label, value, disabled = false, className, onClick, counter } = _a, otherProps = __rest(_a, ["label", "value", "disabled", "className", "onClick", "counter"]);
    const ref = useRef(null);
    const { onSelect, type, focusedTab, onFocus } = useTabBarContext();
    const { selectedTab, setSelectedTab } = useTabsContext();
    const selected = value === selectedTab;
    useEffect(() => {
        const { current } = ref;
        if (selected && current) {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(current);
        }
    }, [selected, ref, onSelect]);
    useEffect(() => {
        const { current } = ref;
        if (focusedTab === value && current) {
            current.focus();
        }
    }, [value, ref, focusedTab]);
    const handleClick = useCallback((e) => {
        setSelectedTab(value);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [value, onClick, setSelectedTab]);
    const clickByEnterOrSpaceKey = useCallback((e) => {
        var _a;
        if (e.key === 'Enter' || e.key === 'Space') {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    }, [ref]);
    const onFocusHandler = useCallback((e) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e.target, value);
    }, [onFocus, value]);
    if (!type) {
        return null;
    }
    const { typographyProps, counterProps } = MAP_TYPE_TO_PROPS[type];
    return (_jsx("button", Object.assign({ type: 'button', role: 'tab', "data-test-id": `tabs__tab-${value}` }, otherProps, { id: value, ref: ref, disabled: disabled, "data-disabled": disabled, className: cn(styles.tab, className), "aria-controls": getTabContentId(value), "aria-selected": selected, "data-selected": selected, "data-type": type, onClick: handleClick, onFocus: onFocusHandler, onKeyDown: clickByEnterOrSpaceKey, children: _jsxs(Typography, Object.assign({ className: styles.container, tag: 'div', family: 'sans' }, typographyProps, { children: [label, counter && _jsx(Counter, Object.assign({ value: counter, "data-test-id": `tabs__tab-counter-${value}` }, counterProps))] })) })));
}
